module.exports = __webpack_public_path__ + "img/Tasted.3594ae0c.png";